import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerClockExclamation, tablerLogin } from '@ng-icons/tabler-icons';
import { AuthService } from '@onrsr/ui/auth';
import { ButtonComponent } from '@onrsr/ui/buttons';
import { ReauthenticationService } from '../../reauthentication.service';

/** Blocks the page while the session is expired; the page underneath keeps its state. */
@Component({
  selector: 'app-session-expired',
  imports: [NgIcon, ButtonComponent],
  templateUrl: './session-expired.html',
  styleUrl: './session-expired.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideIcons({ tablerClockExclamation, tablerLogin })],
})
export class SessionExpired {
  protected readonly reauth = inject(ReauthenticationService);
  protected readonly auth = inject(AuthService);
}
